import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import { saveUserInfo } from "../../../../actions/action_users";
import LoadingOverlay from "../../common/LoadingOverlay";
import Header from "../../layout/Header";
import TwoocaService from "../../../../api/services/TwoocaService";
import { saveRegisterTwoocaInput } from "../../../../actions/action_register_twooca";
import { addParamUrl } from "../../../../utils";
import { isEmptyObject } from "jquery";

class RegisterTwoocaConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectTo: false,
      errorMessage: "",
      loading: false,
      showErrorPopup: false,
      showSuccessPopup: false,
      payload: this.props.registerTwoocaInput.payload,
    };
    this.submitConfirm = this.submitConfirm.bind(this);
    this.hideError = this.hideError.bind(this);
    this.back = this.back.bind(this);
  }

  loading(show) {
    this.setState({ loading: show });
  }

  hideError() {
    if (!this.state.showSuccessPopup) {
      this.setState({
        showErrorPopup: false,
        showSuccessPopup: false,
        errorMessage: "",
      });
      document.getElementsByTagName("html")[0].classList.remove("active-modal");
    }
  }

  showError(message) {
    this.setState({ showErrorPopup: true, errorMessage: message });
    document.getElementsByTagName("html")[0].classList.add("active-modal");
  }

  showSuccessPopup() {
    this.setState({ showSuccessPopup: true });
    document.getElementsByTagName("html")[0].classList.add("active-modal");
  }

  async submitConfirm() {
    this.loading(true);
    try {
      const res = await TwoocaService.createUser(this.state.payload);
      switch (res.status) {
        case 200:
          this.showSuccessPopup();
          break;
        case 400:
          if (res.responseData.errorInfo) {
            if (
              res.responseData.errorInfo.code ==
              "exception.errors.twooca.register.duplicate.email"
            ) {
              this.showError(this.props.t(res.responseData.errorInfo.code));
            } else {
              this.showError(res.responseData.errorInfo.content);
            }
          } else {
            this.showError("エラーが発生しました。再度ご確認ください。");
          }
          break;

        default:
          this.showError("エラーが発生しました。再度ご確認ください。");
          break;
      }
    } catch (error) {
      this.showError("エラーが発生しました。再度ご確認ください。");
    }
    this.loading(false);
  }

  back() {
    this.setState({
      redirectTo: true,
    });
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = '/assets/js/app.js';
    script.async = false;
    document.body.appendChild(script);
    this.script = script;
  }

  componentWillUnmount() {
    if (this.script && this.script.parentNode) {
      this.script.parentNode.removeChild(this.script);
    }
  }

  render() {
    const redirectTo = this.state.redirectTo;
    if (redirectTo === true || isEmptyObject(this.state.payload)) {
      let link = addParamUrl("/mypage/twooca/register", [{}]);
      return <Redirect to={link} />;
    }
    return (
      <div className="twooca bg-white">
        <MetaTags>
          <title>TwooCaアカウント登録・連携</title>
          <meta name="description" content="TwooCaアカウント登録・連携" />
          <meta
            name="twitter:card swiper-slide"
            content="summary_large_image"
          />
          <meta name="twitter:title" content="TwooCaアカウント登録・連携" />
          <meta
            name="twitter:description"
            content="TwooCaアカウント登録・連携"
          />
          <meta
            name="twitter:image"
            content={window.location.origin + "/assets/img/common/ogp.png"}
          />
          <meta name="twitter:site" content="@gochi_meshi" />
          <meta name="twitter:creator" content="@gochi_meshi" />
          <meta name="twitter:image:width" content="300" />
          <meta name="twitter:image:height" content="300" />
          <meta property="og:site_name" content="TwooCaアカウント登録・連携" />
          <meta property="og:title" content="TwooCaアカウント登録・連携" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={window.location.href} />
          <meta
            property="og:image"
            content={window.location.origin + "/assets/img/common/ogp.png"}
          />
          <meta
            property="og:description"
            content={"TwooCaアカウント登録・連携"}
          />
        </MetaTags>
        <Header />
        <main>
          <div className="">
            <div className="fieldset">
              <h1 className="text-center">TwooCaアカウント登録・連携</h1>
            </div>
            <div className="fieldset">
              <p>ご入力・登録内容を確認し、登録確定してください。</p>
            </div>

            <table className="twooca-table not-responsive">
              <thead>
                <tr>
                  <th>項目</th>
                  <th>入力内容</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    メールアドレス<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.email}</td>
                </tr>
                <tr>
                  <td>
                    姓<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.lastName}</td>
                </tr>
                <tr>
                  <td>
                    姓フリガナ<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.lastNameFuri}</td>
                </tr>
                <tr>
                  <td>
                    姓英語表記<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.lastNameEn}</td>
                </tr>
                <tr>
                  <td>
                    名<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.firstName}</td>
                </tr>
                <tr>
                  <td>
                    名フリガナ<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.firstNameFuri}</td>
                </tr>
                <tr>
                  <td>
                    名英語表記<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.firstNameEn}</td>
                </tr>
                <tr>
                  <td>ミドルネーム</td>
                  <td>{this.state.payload.middleName}</td>
                </tr>
                <tr>
                  <td>ミドルネームフリガナ</td>
                  <td>{this.state.payload.middleNameFuri}</td>
                </tr>
                <tr>
                  <td>ミドルネーム英語表記</td>
                  <td>{this.state.payload.middleNameEn}</td>
                </tr>
                <tr>
                  <td>
                    生年月日<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.birthday}</td>
                </tr>
                <tr>
                  <td>
                    電話番号<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.tel}</td>
                </tr>
                <tr>
                  <td>
                    性別<span className="text-danger"> *</span>
                  </td>
                  <td>
                    {this.state.payload.gender == 0
                      ? "男性"
                      : this.state.payload.gender == 1
                      ? "女性"
                      : this.state.payload.gender == 2
                      ? "ノンバイナリー"
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>
                    郵便番号<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.postCode}</td>
                </tr>
                <tr>
                  <td>
                    都道府県<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.prefecture}</td>
                </tr>
                <tr>
                  <td>
                    市区町村<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.city}</td>
                </tr>
                <tr>
                  <td>
                    町域・番地<span className="text-danger"> *</span>
                  </td>
                  <td>{this.state.payload.address}</td>
                </tr>
                <tr>
                  <td>建物名・部屋番号</td>
                  <td>{this.state.payload.building}</td>
                </tr>
              </tbody>
            </table>

            <div className="fieldset">
              <button
                type="button"
                className="btn btn-rect w-100"
                onClick={this.submitConfirm}
              >
                登録確定する
              </button>
            </div>
            <div className="fieldset">
              <button
                type="button"
                className="btn btn-back"
                onClick={this.back}
              >
                前の画面に戻る
              </button>
            </div>
          </div>
        </main>

        <footer className="global-footer footer-mypage">
          <section className="global-footer-nav-area">
            <div className="container">
              <div className="section-header">
                <div className="heading-xs">
                  <div className="title">
                    <h1>
                      <img
                        src="/assets/img/common/logo_gochi_footer.svg"
                        alt="ごちめし"
                        loading="lazy"
                      />
                    </h1>
                  </div>
                </div>
              </div>
              <div className="section-body footer-nav">
                <ul className="footer-link-area">
                  <li>
                    <a href="https://gochimeshi.com/policy/">各種規約</a>
                  </li>
                  <li>
                    <a href="https://gochimeshi.com/policy/privacy/">
                      プライバシーポリシー
                    </a>
                  </li>
                  <li>
                    <a href="https://gochimeshi.com/policy/legal/">
                      特定商取引法に基づく表記
                    </a>
                  </li>
                  <li>
                    <a href="https://user-guide.gochimeshi.com/">
                      よくある質問
                    </a>
                  </li>
                  <li>
                    <a href="https://gochimeshi.com/info/">お問い合わせ</a>
                  </li>
                  <li>
                    <a href="https://www.gigi.tokyo/">
                      運営会社（Gigi株式会社）
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <div className="copyright">
            <small>
              GOCHI®︎ ごちめし®︎ こどもごちめし® 社食ごちめし™︎ ︎ ︎ さきめし®︎
              は、
              <br />
              Gigi株式会社の登録商標です
              <br />
              GOCHIプラットフォームの機能は、
              <br />
              特許取得済み（特許番号：特許第7572763号）
              <br />© Gigi Inc.
            </small>
          </div>
        </footer>

        <div className="modal-group">
          {/* Popup Error */}
          <div className="modal-mask" onClick={this.hideError} />
          <div
            className={`modal modal-profile modal-profile-01 modal-01 modal-lg history-modal policy-gochi-kid-modal policy-gochi-kid-modal-1 ${
              this.state.showErrorPopup ? "is-show" : ""
            }`}
          >
            <div className="modal-header-history">
              <button
                className="modal-btn modal-btn-close"
                id="modalClose"
                onClick={this.hideError}
                type="button"
              >
                <svg className="icon">
                  <title>閉じる</title>
                  <use xlinkHref="/assets/img/common/icon.svg#times" />
                </svg>
              </button>
            </div>
            <div className={`modal-body`}>
              <div className="d-flex justify-content-center mb-2">
                <div className="dot mr-2"></div>
                <h1>登録エラー</h1>
              </div>
              <p className="text-danger fs-16">
                {this.state.errorMessage !=
                "exception.errors.twooca.register.duplicate.email" ? (
                  this.state.errorMessage
                ) : (
                  <>
                    メールアドレスは、すでにTwooCaアカウントとして既に登録済みです。
                    <br />
                    GOCHIマイページよりGOCHIアカウントのメールアドレスをご変更いただくか、TwooCaアカウントのメールアドレス変更をご検討ください。
                  </>
                )}
              </p>
              <a href="/mypage" className="btn btn-rect w-100 btn-danger fs-16">
                GOCHIマイページへ
              </a>
            </div>
          </div>

          {/* Popup Success */}
          <div
            className={`modal modal-profile modal-profile-01 modal-01 modal-lg history-modal policy-gochi-kid-modal policy-gochi-kid-modal-1 twooca-register-success-modal ${
              this.state.showSuccessPopup ? "is-show" : ""
            }`}
          >
            <div className="modal-header-history"></div>
            <div className={`modal-body`}>
              <h1 className="text-center">
                TwooCaアカウント
                <br />
                登録・連携完了
              </h1>
              <p>TwooCaアカウント登録・連携を完了しました。</p>
              <p>
                TwooCaチャージのご利用には、TwooCaの「
                <span className="text-danger">
                  リアルVisaカード（プリペイドカード）
                </span>
                」が必要です。
                <br />
                続けて、以下サポートページに記載の手順でカードの発行手続きをお願いします。
              </p>
              <div>【注意事項】</div>
              <ul>
                <li>
                  リアルVisaカードはお申し込みからお手元に届くまで2〜3週間程度かかります。お早めの発行手続きをお願いいたします。
                </li>
                <li>チャージは反映まで時間がかかる場合があります。</li>
              </ul>
              <p>
                システムエラー等により完了が遅れることもあるため、ご利用前に余裕をもってチャージを行ってください。
              </p>
              <p>
                こどもごちめしTwooCaチャージのご利用方法:
                <br />
                <a
                  href="https://support.gochimeshi.com/s/article/twooca-charge-use"
                  target="_blank"
                  className="twooca-link"
                >
                  https://support.gochimeshi.com/s/article/twooca-charge-use
                </a>
              </p>
              <a href="/mypage/twooca" className="btn btn-rect w-100">
                マイページに戻る
              </a>
            </div>
          </div>
        </div>
        <LoadingOverlay loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  saveUserInfo: (isLogined, isGuest, userInfo) =>
    dispatch(saveUserInfo(isLogined, isGuest, userInfo)),
  saveRegisterTwoocaInput: (payload) =>
    dispatch(saveRegisterTwoocaInput(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RegisterTwoocaConfirm));
